import { Alert, Skeleton, Stack } from '@mantine/core';
import { IconAlertTriangle } from '@tabler/icons-react';
import type { ReactNode } from 'react';
import { errorText } from '../api';

/** Wspólne stany ładowania (szkielet treści zamiast kręcącego się kółka) i błędu dla zapytań. */
export function QueryState({ isLoading, error, children, lines = 4 }: { isLoading: boolean; error: unknown; children: ReactNode; lines?: number }) {
  if (isLoading)
    return (
      <Stack gap="sm" p="md" aria-busy="true" aria-label="Ładowanie">
        <Skeleton h={18} w="40%" radius="sm" />
        {Array.from({ length: lines }, (_, i) => (
          <Skeleton key={i} h={14} w={`${90 - i * 12}%`} radius="sm" />
        ))}
      </Stack>
    );
  if (error)
    return (
      <Alert color="red" icon={<IconAlertTriangle />} title="Nie udało się pobrać danych" style={{ whiteSpace: 'pre-line' }}>
        {errorText(error)}
      </Alert>
    );
  return <>{children}</>;
}
